import { storage } from '../firebaseConfig';
import { ref, uploadBytes, getDownloadURL, deleteObject } from 'firebase/storage';
import { v4 as uuidv4 } from 'uuid';

export const ImageStorageService = {
  /**
   * Sube una imagen a Firebase Storage
   * @param file Archivo a subir
   * @param folder Carpeta donde se guardará (ej: 'equipos', 'socios')
   * @returns URL de la imagen subida
   */
  async uploadImage(file: File, folder: string): Promise<string> {
    try {
      // Crear un nombre único para el archivo
      const fileExtension = file.name.split('.').pop();
      const fileName = `${uuidv4()}.${fileExtension}`;
      const storageRef = ref(storage, `${folder}/${fileName}`);
      
      // Subir el archivo
      const snapshot = await uploadBytes(storageRef, file);
      
      // Obtener la URL de descarga
      const downloadURL = await getDownloadURL(snapshot.ref);
      
      return downloadURL;
    } catch (error) {
      console.error('Error al subir imagen:', error);
      throw new Error('No se pudo subir la imagen. Inténtalo de nuevo.');
    }
  },
  
  /**
   * Elimina una imagen de Firebase Storage
   * @param imageUrl URL de la imagen a eliminar
   */
  async deleteImage(imageUrl: string): Promise<void> {
    try {
      // Extraer la ruta del archivo de la URL
      const urlObj = new URL(imageUrl);
      const pathWithToken = urlObj.pathname;
      // Eliminar el token de la URL y extraer la ruta
      const path = decodeURIComponent(pathWithToken.split('/o/')[1].split('?')[0]);
      
      const imageRef = ref(storage, path);
      await deleteObject(imageRef);
    } catch (error) {
      console.error('Error al eliminar imagen:', error);
      // No lanzamos error para no interrumpir el flujo si la eliminación falla
    }
  },
  
  /**
   * Reemplaza una imagen existente con una nueva
   * @param oldImageUrl URL de la imagen antigua a reemplazar
   * @param file Nuevo archivo a subir
   * @param folder Carpeta donde se guardará
   * @returns URL de la nueva imagen
   */
  async replaceImage(oldImageUrl: string | undefined, file: File, folder: string): Promise<string> {
    // Si hay una imagen anterior, intentar eliminarla
    if (oldImageUrl) {
      await this.deleteImage(oldImageUrl).catch(err => console.log('No se pudo eliminar la imagen anterior'));
    }
    
    // Subir la nueva imagen
    return await this.uploadImage(file, folder);
  }
};
